import { Button } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useEditQuote } from '../../hooks/useEditQuote'

export const EditQuoteButton = (): ReactElement => {
  const { t } = useTranslation()
  const { editQuote } = useEditQuote()

  const handleEditQuoteButtonClick = useCallback(() => {
    editQuote()
  }, [editQuote])

  return (
    <Button icon="squarePen" onClick={handleEditQuoteButtonClick} variant="outlined">
      {t('quotes.view.edit_quote')}
    </Button>
  )
}
